var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",style:(_vm.defaultStyle),attrs:{"href":_vm.link,"target":_vm.newTab ? '_blank' : ''},on:{"mouseenter":_vm.handleLinkMoveEnter,"mouseleave":_vm.handleLinkMoveLeave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }